import * as React from 'react';
import modulesData from '../Data/ModulesData';
import { Link } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';

const Modules = () => {
  const [value, setValue] = React.useState(0);
  const handleChange = (_: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  function getTabComponents(semester: number) {
    const year = Math.floor((semester - 1) / 2) + 1;
    const currSem = semester % 2 === 0 ? 2 : 1;
    return (
      <>
        {modulesData
          .filter(module => module.YearSem === `Y${year}S${currSem}`)
          .map(module => (
            <div
              key={module.id}
              className="module-card"
            >
              <h2 className="module-title">{module.moduleCode}: {module.moduleName}</h2>
              <div className="module-actions">
                <a
                  href={module.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="btn-primary"
                >
                  View on NUSMods
                </a>
                <Link to={`/modules/${module.id}`} className="btn-secondary">
                  Read More
                </Link>
              </div>
            </div>
          ))}
      </>
    );
  }

  return (
    <div className="pt-16">
      <section className="section-padding">
        <div className="container-custom">
          <h1 className="text-4xl md:text-5xl font-bold mb-6 text-gradient text-center">My Modules</h1>
          <div className="modules-box">
            <Box sx={{ width: '100%' }}>
              <Tabs
                onChange={handleChange}
                value={value}
                aria-label="Tabs where selection follows focus"
                selectionFollowsFocus
                variant="scrollable"
                scrollButtons
                allowScrollButtonsMobile
              >
                <Tab value={1} sx={{
                  color: value === 0 ? '#6cb2ff' : '#b0b8d1',
                  fontWeight: 'bold'
                }} label="Y1S1" />
                <Tab value={2} sx={{
                  color: value === 1 ? '#6cb2ff' : '#b0b8d1',
                  fontWeight: 'bold'
                }} label="Y1S2" />
                <Tab value={3} sx={{
                  color: value === 2 ? '#6cb2ff' : '#b0b8d1',
                  fontWeight: 'bold'
                }} label="Y2S1" />
                <Tab value={4} sx={{
                  color: value === 3 ? '#6cb2ff' : '#b0b8d1',
                  fontWeight: 'bold'
                }} label="Y2S2" />
                <Tab value={5} sx={{
                  color: value === 4 ? '#6cb2ff' : '#b0b8d1',
                  fontWeight: 'bold'
                }} label="Y3S1" />
                <Tab value={6} sx={{
                  color: value === 5 ? '#6cb2ff' : '#b0b8d1',
                  fontWeight: 'bold'
                }} label="Y3S2" />
                <Tab value={7} sx={{
                  color: value === 6 ? '#6cb2ff' : '#b0b8d1',
                  fontWeight: 'bold'
                }} label="Y4S1" />
                <Tab value={8} sx={{
                  color: value === 7 ? '#6cb2ff' : '#b0b8d1',
                  fontWeight: 'bold'
                }} label="Y4S2" />
              </Tabs>
              <div className="mt-6">
                {getTabComponents(value)}
              </div>
            </Box>
          </div>
        </div>
      </section>
      <style>
        {`
          .modules-box {
            background-color: #23283b;
            border-radius: 1rem;
            box-shadow: 0 4px 24px rgba(255, 202, 202, 0.15);
            padding: 2rem;
            padding-left: 5rem;
            padding-right: 5rem;
            max-width: 40rem;
            margin-left: auto;
            margin-right: auto;
            display: flex;
            flex-direction: column;
            align-items: stretch;
          }
          .module-card {
            background-color: #23283b;
            border-radius: 0.75rem;
            box-shadow: 0 4px 24px rgba(255, 202, 202, 0.15);
            padding: 1.5rem;
            margin-bottom: 1rem;
            max-width: 36rem;
            margin-left: auto;
            margin-right: auto;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
          }
          .module-title {
            font-size: 1.25rem;
            font-weight: bold;
            color: #6cb2ff;
            margin-bottom: 0.75rem;
          }
          .module-actions {
            margin-top: 0.5rem;
            display: flex;
            flex-direction: row;
            gap: 0.75rem;
            width: 100%;
          }
          .btn-primary, .btn-secondary {
            width: fit-content;
          }
        `}
      </style>
    </div>
  );
};

export default Modules;


